import { api } from 'api/api';
import { AccountContext } from 'components/AccountContext';
import { userIsSubscriber } from 'components/Utils/theme';
import { useContext, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

const useModelPagamentoTelemed = () => {
  const { setUser, user, setPage } = useContext(AccountContext);
  const assinante = userIsSubscriber(user);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const state = useLocation();
  const [metadataTelemed, setMetadataTelemed] = useState([]);
  const [pet, setPet] = useState(null);
  const [valorProc, setValorProc] = useState(0);
  const [valorCredito, setValorCredito] = useState(0);
  const [isCreditoPago, setCreditoPago] = useState(false);
  const [voucherValido, setVoucherValido] = useState(null);
  const [errorVoucher, setErrorVoucher] = useState(null);
  const [valor, setValor] = useState({
    prontoAtendimento: {
      valor_clinico: 0,
      valor_pediatra: 0,
      valor_veterinario: 0,
      id_procedimento_clinico: 0,
      id_procedimento_pediatra: 0,
      id_procedimento_veterinario: 0,
      valor_clinico_assinante: 0,
      valor_pediatra_assinante: 0,
      valor_veterinario_assinante: 0,
    },
    especialista: {
      valor_cardiologista: 0,
      valor_ortopedista: 0,
      valor_dermatologista: 0,
      valor_nutricionista: 0,
      id_procedimento_cardiologista: 0,
      id_procedimento_ortopedista: 0,
      id_procedimento_dermatologista: 0,
      id_procedimento_nutricionista: 0,
    },
    prontoAtendimento_gratis: false,
  });

  useEffect(() => {
    setPage('Planos Deovita');
  }, [user]);

  async function fetchValoresTelemedicina() {
    try {
      setLoading(true);
      setError(null);
      const url = `${ENDPOINT}/pacientes/pesquisarValoresTelemedicina`;
      const postsData = await api(`${url}`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: user.username,
          assinante: assinante,
          plano_id: user.id_plano,
        }),
      });
      const response = await postsData.json();
      setValor(response);
    } catch (error) {
      setError('!');
    } finally {
      setLoading(false);
    }
  }

  async function fetchValorProc() {
    const postsData = await api(`${ENDPOINT}/clients/valorProc`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ pet: pet }),
    });
    const response = await postsData.json();
    setValorProc(response.valortotal);
    setMetadataTelemed(response);
  }

  async function fetchCreditoId() {
    try {
      setError(false);
      setLoading(true);
      const postsData = await api(`${ENDPOINT}/clients/creditoClienteId/${user.username}/${tipoAtendimento}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const response = await postsData.json();
      console.log('response credito id!! ', response);
      setUser((prevUser) => ({
        ...prevUser,
        credito_id: response.credito_id,
        credito_valor: response.valor,
      }));
      setValorCredito(response.valor);
      if (response.credito_id) {
        setCreditoPago(true);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setError(true);
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchCreditoId();
    fetchValorProc();
    fetchValoresTelemedicina();

    return () => {
      if (window.socketRef && typeof window.socketRef.destroy === 'function') {
        window.socketRef.destroy();
      }
    };
  }, []);

  const tipoAtendimento = state?.state?.tipoAtendimento || null;
  const valorCobrar = useMemo(() => {
    if (!tipoAtendimento) return null;
    if (!valor) return null;
    if (loading) return null;
    if (tipoAtendimento === 'clinico') {
      return { valor: valor.prontoAtendimento.valor_clinico, id: valor.prontoAtendimento.id_procedimento_clinico };
    } else if (tipoAtendimento === 'pediatra') {
      return { valor: valor.prontoAtendimento.valor_pediatra, id: valor.prontoAtendimento.id_procedimento_pediatra };
    } else if (tipoAtendimento === 'veterinario') {
      return { valor: valor.prontoAtendimento.valor_veterinario, id: valor.prontoAtendimento.id_procedimento_veterinario };
    }
    return 0;
  }, [tipoAtendimento, valor]);

  const creditoPago = user.credito_id !== null && user.credito_id !== undefined && user.credito_id !== 0;
  const valorCreditoNum = Number(user.credito_valor || valorCredito);

  const pago = useMemo(() => {
    if (user.credito_id) {
      return true;
    }
    return false;
  }, [isCreditoPago, user.credito_id, creditoPago, valorCobrar, valorCreditoNum]);
  let data_parcela = '';
  if (user?.qntdeParcelas?.countParcelas > 0) {
    data_parcela = user?.qntdeParcelas?.datasParcelas !== null ? new Date(user?.qntdeParcelas?.datasParcelas[0]) : null;
    if (data_parcela !== null) {
      const dia = user?.qntdeParcelas?.forma_pagamento === 13 ? 60 : 0;
      data_parcela.setDate(data_parcela?.getDate() + dia);
    }
  }
  const dataAtual = new Date();
  const clientePendente = user?.loggedIn && user?.qntdeParcelas?.countParcelas && user?.qntdeParcelas?.countParcelas > 0 && dataAtual >= data_parcela;

  async function fetchVoucherTelemedicina(codigo) {
    try {
      const postsData = await api(`${ENDPOINT}/pacientes/voucher`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ tipo: 'Telemedicina', codigo: codigo, username: user.username }),
      });
      const response = await postsData.json();

      if (response.success === true || response.success === 'true') {
        setVoucherValido(response.voucher);
        setErrorVoucher(null);
      } else {
        setVoucherValido(false);
        setErrorVoucher('Voucher inválido');
      }
    } catch (error) {
      setError(true);
      setErrorVoucher('Voucher inválido');
    }
  }

  async function fetchVincularVoucher(codigo, valor_desconto, valor_original, cpf = null) {
    try {
      const postsData = await api(`${ENDPOINT}/pacientes/vincularVoucher`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: user.username || cpf,
          voucher: codigo,
          origem: 'Telemedicina',
          transaction_id: null,
          valor_original: valor_original,
          valor_desconto: valor_desconto,
        }),
      });
      const response = await postsData.json();

      if (response.success === true || response.success === 'true') {
        setVoucherValido(response.voucher);
        setErrorVoucher(null);
      } else {
        setVoucherValido(false);
        setErrorVoucher('Voucher inválido');
      }
    } catch (error) {
      console.log('Error fetchVincularVoucher:', error);
      setError(true);
      setErrorVoucher('Voucher inválido');
    }
  }

  useEffect(() => {
    return () => {
      if (user && user.voucher && user.voucher.voucher && user.voucher.voucher.voucher_type === 'Telemedicina') {
        setUser((prevUser) => ({
          ...prevUser,
          voucher: null,
        }));
      }
    };
  }, [user, setUser]);

  return {
    valor,
    loading,
    error,
    assinante,
    tipoAtendimento,
    valorCobrar,
    pago,
    metadataTelemed,
    valorProc,
    user,
    isCreditoPago,
    setUser,
    clientePendente,
    fetchVoucherTelemedicina,
    errorVoucher,
    voucherValido,
    fetchVincularVoucher,
    setVoucherValido,
    setErrorVoucher,
  };
};

export default useModelPagamentoTelemed;
